import { call, put, takeEvery } from "redux-saga/effects"

import { GET_BRANCHES, ADD_NEW_BRANCH, UPDATE_BRANCH, DELETE_BRANCH } from "./actionTypes";
import {
    getBranchesSuccess,
    getBranchesFail,
    addBranchSuccess,
    addBranchFail,
    updateBranchSuccess,
    updateBranchFail,
    deleteBranchSuccess,
    deleteBranchFail,
   
} from "./actions"

import {
    getBranches,
    addNewBranch,
    updateBranch,
    deleteBranch,
   
} from "helpers/branches/branches_backend_helper";
import { toast } from "react-toastify";

function* fetchBranches() {
    try {
        const response = yield call(getBranches)
        yield put(getBranchesSuccess(response))
    } catch (error) {
        yield put(getBranchesFail(error))
    }
}

function* onAddNewBranch({ payload }) {
    try {

        
        const response = yield call(addNewBranch, payload)

        console.log("RESPONSE:", response);
        yield put(addBranchSuccess(response.data.branch))
        toast.success(response.data.message, { autoClose: 2000 });
    } catch (error) {
        console.log("ERROR:", error);
        yield put(addBranchFail(error))
        toast.error(error.response?.data?.message, { autoClose: 2000 });
    }
}

/*
function* onUpdateBranch({ payload: data }) {
    try {
        const response = yield call(updateBranch, data)
        yield put(updateBranchSuccess(response))
        toast.success("Branch  Updated Successfully", { autoClose: 2000 });
    } catch (error) {
        yield put(updateBranchFail(error))
        toast.error("Branch  Updated Failed", { autoClose: 2000 });
    }
}
    */

function* onUpdateBranch({ payload}) {
    try {
        console.log("UPDATE: ", payload);
        const response = yield call(updateBranch, payload)
        yield put(updateBranchSuccess(response.data.branch))
        toast.success(response.data.message, { autoClose: 2000 });
    } catch (error) {
        yield put(updateBranchFail(error))
        toast.error(error.response?.data?.message, { autoClose: 2000 });
    }
}

function* onDeleteBranch({ payload: data }) {

    try {
        const response = yield call(deleteBranch, data)
        yield put(deleteBranchSuccess(response.branch_id))
        toast.success(response.message, { autoClose: 2000 });
    } catch (error) {
        yield put(deleteBranchFail(error))
        toast.error(error.response?.data?.message, { autoClose: 2000 });
    }
}


function* branchSaga() {
    yield takeEvery(GET_BRANCHES, fetchBranches)
    yield takeEvery(ADD_NEW_BRANCH, onAddNewBranch)
    yield takeEvery(UPDATE_BRANCH, onUpdateBranch)
    yield takeEvery(DELETE_BRANCH, onDeleteBranch)
}

export default branchSaga;